import React, { Component, PropTypes } from 'react';
import classes from './Loading.scss';
import cn from 'classnames';

export default class Loading extends Component {
  render() {
    return (
      <div className={cn(classes.spinner, classes.loading, this.props.className, classes[this.props.size])}>
        <img src="/loading.gif" />
      </div>
    );
    // return (
    //   <div className={cn(classes.spinner, classes.loading, this.props.className, classes[this.props.size])} />
    // );
  }
}
